import React from 'react';

import { Grid, makeStyles, Typography, useMediaQuery } from '@material-ui/core';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';

const useStyles = makeStyles((theme) => {
  return {
    image: {
      border: '1px solid #E7E7E7',
      borderRadius: '5px',
      height: '77px',
      width: '100%',
      [theme.breakpoints.up('lg')]: {
        height: '50px',
        width: '60px',
      },
    },
    index: {
      color: '#172B4D',
      fontSize: '14px',
      fontWeight: 'bold',
      lineHeight: '16px',
      width: '1.5rem',
    },
    item: {
      lineHeight: '0px',
      paddingRight: '0px',
      [theme.breakpoints.up('lg')]: {
        paddingRight: '0.5rem',
      },
    },
    itemRelative: {
      position: 'relative',
    },
    playIcon: {
      fill: theme.palette.primary.main,
      height: '28px',
      marginLeft: '6px',
      width: '28px',
    },
    playIconMobile: {
      height: 'auto',
      width: '40px',
    },
    playIconMobileContainer: {
      left: '50%',
      position: 'absolute',
      top: '50%',
      transform: 'translateX(-60%) translateY(-50%)',
    },
    title: {
      color: '#172B4D',
      fontSize: '12px',
      fontWeight: '600',
      lineHeight: '15px',
      marginTop: '6px',
      textAlign: 'left',
      whiteSpace: 'normal',
      [theme.breakpoints.up('lg')]: {
        fontSize: '13px',
        marginTop: '0px',
      },
    },
  };
});
export default ({ thumbnail, title, index, isPlaying }) => {
  const classes = useStyles();
  const isDesktop = useMediaQuery((theme) => theme.breakpoints.up('lg'));

  const renderDesktopArrow = () =>
    isPlaying &&
    isDesktop && (
      <Grid item className={classes.item}>
        <PlayArrowIcon className={classes.playIcon} />
      </Grid>
    );

  const renderMobileArrow = () =>
    isPlaying &&
    !isDesktop && (
      <div className={classes.playIconMobileContainer}>
        <PlayArrowIcon className={classes.playIconMobile} style={{ fill: '#FFFFFFCC' }} />
      </div>
    );

  return (
    <Grid container alignItems="center" wrap={(isDesktop && 'nowrap') || 'wrap'}>
      {renderDesktopArrow()}
      <Grid item xs={!isDesktop && 12} className={`${classes.item} ${classes.itemRelative}`}>
        <img className={classes.image} src={thumbnail} alt={title} />
        {renderMobileArrow()}
      </Grid>
      <Grid item xs={!isDesktop && 12} className={classes.item}>
        <Typography className={classes.title} align="left">
          {title}
        </Typography>
      </Grid>
    </Grid>
  );
};
